if($('.product').length){
	function mhproduct(){
		$('.product').each(function(){
			$(this).find('.ratings-wrapper').append($(this).find('.prices'))
			$(this).find('span[data-micro="sku"]').text()
			
		})
		if($('#productsTop .product').length){
			$('#productsTop .product').each(function(){
				if(!$(this).find('.detail-btn').length){
					$(this).find('.ratings-wrapper').append('<div class="detail-btn"><a href="'+$(this).find('a.name').attr('href')+'" class="btn btn-primary">Detail</a></div>')
				}
				
			})
		}
	};
	mhproduct();

	document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    	mhproduct();
	});
	$(document).on("ShoptetDOMAdvancedOrderLoaded",function(){
		mhproduct();	
	});
	document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    	mhproduct();
	});
}

